import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
import { Button } from "@/components/ui/button";
export const Footer = () => {
  return <footer className="bg-gradient-to-br from-indigo-900 to-indigo-950 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo and About */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold bg-gradient-to-r from-indigo-200 to-purple-200 bg-clip-text text-transparent">
              Obotan
            </h3>
            <p className="text-indigo-200 text-sm">Obotan provides an innovative credit solution backed by your assets, enabling you to access loans through crowdfunding, and shop with partner merchants.</p>
            <div className="flex space-x-4 pt-4">
              <a href="#" className="text-indigo-200 hover:text-white transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-indigo-200 hover:text-white transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-indigo-200 hover:text-white transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-indigo-200 hover:text-white transition-colors">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-semibold text-lg border-b border-indigo-700 pb-2">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-indigo-200 hover:text-white transition-colors text-sm">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-indigo-200 hover:text-white transition-colors text-sm">About Us</Link>
              </li>
              <li>
                <Link to="/borrowers" className="text-indigo-200 hover:text-white transition-colors text-sm">Borrowers</Link>
              </li>
              <li>
                <Link to="/lenders" className="text-indigo-200 hover:text-white transition-colors text-sm">Lenders</Link>
              </li>
              <li>
                <Link to="/vendors" className="text-indigo-200 hover:text-white transition-colors text-sm">Vendors</Link>
              </li>
              <li>
                <Link to="/real-estate" className="text-indigo-200 hover:text-white transition-colors text-sm">Real Estate</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="font-semibold text-lg border-b border-indigo-700 pb-2">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm">
                <MapPin size={16} className="text-indigo-300" />
                <span className="text-indigo-200">495 Trade fair Cir, Accra, Ghana</span>
              </li>
              <li className="flex items-center gap-2 text-sm">
                <Phone size={16} className="text-indigo-300" />
                <span className="text-indigo-200">+1 (234) 567-8901</span>
              </li>
              <li className="flex items-center gap-2 text-sm">
                <Mail size={16} className="text-indigo-300" />
                <span className="text-indigo-200">info@obotan.com</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="space-y-4">
            <h4 className="font-semibold text-lg border-b border-indigo-700 pb-2">Newsletter</h4>
            <p className="text-indigo-200 text-sm">Subscribe to our newsletter to receive updates on our services and offers.</p>
            <div className="flex flex-col space-y-2">
              <input type="email" placeholder="Your email address" className="px-4 py-2 rounded-md bg-indigo-800 border border-indigo-700 text-white placeholder:text-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              <Button className="bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 text-white">
                Subscribe
              </Button>
            </div>
          </div>
        </div>

        <div className="border-t border-indigo-800 mt-12 pt-6 text-center text-indigo-300 text-sm">
          <p>© {new Date().getFullYear()} Obotan. All rights reserved.</p>
        </div>
      </div>
    </footer>;
};